import { Flex, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { FC } from 'react';

import { ListItem } from '@/components/ui/features/schedule/ScheduleListView/components/ListItem';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useUserEventTimezone } from '@/hooks/useUserEventTimezone';
import { ThinEventSession } from '@/resources/ThinEventSession';

interface IListGroupProps {
  date: string;
  sessions: Array<ThinEventSession>;
  newTab: boolean;
  mutateSession: () => void;
}
export const ListGroup: FC<IListGroupProps> = ({ date, sessions, newTab, mutateSession }) => {
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const timeZone = useUserEventTimezone(eventId);
  const zonedDate = utcToZonedTime(date, timeZone);

  return (
    <Flex flexDir="column" mb="10">
      <Text
        fontFamily="heading"
        color="gray.600"
        fontSize="sm"
        fontWeight="bold"
        mb={{ base: 2, lg: 8 }}
        px={{ base: 4, lg: 10 }}
      >
        {format(zonedDate, 'HH')}:00
      </Text>
      {sessions.map((session) => (
        <ListItem mutateSession={mutateSession} newTab={newTab} key={session.id} session={session} />
      ))}
    </Flex>
  );
};
